// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout follows the member management page (user-company): the page shell comes from the
   global .div-esign-tab-list / .table-filter / .table-wrapper rules, and the table keeps the
   default auto layout so columns still size to their content. Widths below are hints only.
   The empty-state message reuses the site-wide .div-notfound / .msg-table-notfound styling
   (see _app-theme.scss), so no component-scoped rule is needed for it here. */

/* Toolbar button styling, copied from user-company: these rules are component-scoped there,
   so the outlined "add" button only looks right if each page carries its own copy. */
.toolbar {
   align-items: center;
}

.menu > li {
   float: left;
}

.menu > li + li {
   margin-left: 1em;
}

.menu button {
   padding: 0 12px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.menu button i {
   font-size: 16px;
   margin-right: 10px;
}

.mat-column-clientId {
   width: 30%;
}

/* Long descriptions truncate with an ellipsis instead of stretching the row; the full text is
   still available via the title tooltip, matching the file-name column on the Forms list. */
.mat-column-description {
   width: 25%;
   max-width: 0;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

.mat-column-updateBy {
   width: 20%;
}

.mat-column-updateDate {
   width: 15%;
}

.mat-column-actions {
   width: 10%;
   text-align: right;
}

/* Keep the sticky header opaque so rows don't show through while scrolling. */
th.mat-header-cell {
   background: #fff;
   z-index: 2;
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/allow-client/allow-client.component.css"],"names":[],"mappings":"AAAA;;;;8EAI8E;;AAE9E;qFACqF;AACrF;GACG,mBAAmB;AACtB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,UAAU;AACb;;AAEA;4FAC4F;AAC5F;GACG,UAAU;GACV,YAAY;GACZ,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,UAAU;GACV,iBAAiB;AACpB;;AAEA,8EAA8E;AAC9E;GACG,gBAAgB;GAChB,UAAU;AACb","sourcesContent":["/* Layout follows the member management page (user-company): the page shell comes from the\n   global .div-esign-tab-list / .table-filter / .table-wrapper rules, and the table keeps the\n   default auto layout so columns still size to their content. Widths below are hints only.\n   The empty-state message reuses the site-wide .div-notfound / .msg-table-notfound styling\n   (see _app-theme.scss), so no component-scoped rule is needed for it here. */\n\n/* Toolbar button styling, copied from user-company: these rules are component-scoped there,\n   so the outlined \"add\" button only looks right if each page carries its own copy. */\n.toolbar {\n   align-items: center;\n}\n\n.menu > li {\n   float: left;\n}\n\n.menu > li + li {\n   margin-left: 1em;\n}\n\n.menu button {\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.menu button i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.mat-column-clientId {\n   width: 30%;\n}\n\n/* Long descriptions truncate with an ellipsis instead of stretching the row; the full text is\n   still available via the title tooltip, matching the file-name column on the Forms list. */\n.mat-column-description {\n   width: 25%;\n   max-width: 0;\n   white-space: nowrap;\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n.mat-column-updateBy {\n   width: 20%;\n}\n\n.mat-column-updateDate {\n   width: 15%;\n}\n\n.mat-column-actions {\n   width: 10%;\n   text-align: right;\n}\n\n/* Keep the sticky header opaque so rows don't show through while scrolling. */\nth.mat-header-cell {\n   background: #fff;\n   z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
